module.exports = __webpack_public_path__ + "static/media/procesos.9562b0c1.svg";